@if (this.isIb) {
    Klant: {{ getNaamIb() }}
    <div class="space10"></div>
    Middel: {{ getMiddelIb() }}

    <div class="space20"></div>

    <form [formGroup]="formGroupIb">
        @for (field of ibFields; track field.formControlName) {
            @if (hasValue(field.formControlName)) {
                <snelstart-ui-number-form-control
                        [disabledControl]="true"
                        [prefix]="field.prefix"
                        [showAllDecimals]="false"
                        [formControlName]="field.formControlName"
                        [id]="field.formControlName"
                        [label]="field.label"
                        align="right"
                        class="custom-input-250">
                </snelstart-ui-number-form-control>
            }
        }
    </form>
}

@if (this.isZvw) {
    Klant: {{ getNaamZvw() }}
    <div class="space10"></div>
    Middel: {{ getMiddelZvw() }}

    <div class="space20"></div>

    <form [formGroup]="formGroupZvw">
        @for (field of zvwFields; track field.formControlName) {
            @if (hasValueZvw(field.formControlName)) {
                <snelstart-ui-number-form-control
                        [disabledControl]="true"
                        [prefix]="field.prefix"
                        [showAllDecimals]="false"
                        [formControlName]="field.formControlName"
                        [id]="field.formControlName"
                        [label]="field.label"
                        align="right"
                        class="custom-input-250">
                </snelstart-ui-number-form-control>
            }
        }
    </form>
}

@if (this.isVpb) {
    Klant: {{ getNaamVpb() }}
    <div class="space10"></div>
    Middel: {{ getMiddelVpb() }}

    <div class="space20"></div>

    <form [formGroup]="formGroupVpb">
        @for (field of vpbFields; track field.formControlName) {
            @if (hasValueVpb(field.formControlName)) {
                <snelstart-ui-number-form-control
                        [disabledControl]="true"
                        [prefix]="field.prefix"
                        [showAllDecimals]="false"
                        [formControlName]="field.formControlName"
                        [id]="field.formControlName"
                        [label]="field.label"
                        align="right"
                        class="custom-input-250">
                </snelstart-ui-number-form-control>
            }
        }
    </form>
}

@if (this.isBtw) {
    Klant: {{ getNaamBtw() }}
    <div class="space10"></div>
    Middel: {{ getMiddelBtw() }}

    <div class="space20"></div>

    <form [formGroup]="formGroupBtw">
        <div formGroupName="bedragAanslag">
            @for (field of btwFields; track field.formControlName) {
                @if (hasValueBtw(field.formControlName)) {
                    <snelstart-ui-number-form-control
                            [disabledControl]="true"
                            [prefix]="field.prefix"
                            [showAllDecimals]="false"
                            [formControlName]="field.formControlName"
                            [id]="field.formControlName"
                            [label]="field.label"
                            align="right"
                            class="custom-input-250">
                    </snelstart-ui-number-form-control>
                }
            }
        </div>
    </form>
}

@if (this.isTsl) {
    Klant: {{ getNaamTsl() }}
    <div class="space10"></div>
    Middel: {{ getMiddelTsl() }}

    <div class="space20"></div>

    <form [formGroup]="formGroupTsl">
        <div formGroupName="meldingen">
            @for (field of tslMeldingenFields; track field.formControlName) {
                @if (hasValueTslMeldingen(field.formControlName)) {
                    <snelstart-ui-number-form-control
                            [disabledControl]="true"
                            [prefix]="field.prefix"
                            [showAllDecimals]="false"
                            [formControlName]="field.formControlName"
                            [id]="field.formControlName"
                            [label]="field.label"
                            align="right"
                            class="custom-input-250">
                    </snelstart-ui-number-form-control>
                }
            }
        </div>

        <div formGroupName="regeling">
            @for (field of tslRegelingFields; track field.formControlName) {
                @if (hasValueTslRegeling(field.formControlName)) {
                    <snelstart-ui-number-form-control
                            [disabledControl]="true"
                            [prefix]="field.prefix"
                            [showAllDecimals]="false"
                            [formControlName]="field.formControlName"
                            [id]="field.formControlName"
                            [label]="field.label"
                            align="right"
                            class="custom-input-250">
                    </snelstart-ui-number-form-control>
                }
            }
        </div>
    </form>
}
